import { useEffect, useState } from "react";
import { MdSportsSoccer } from "react-icons/md";

const ringColors = ["#143287", "#325FDC", "#91BEFA"];
const ballColors = ["#143287", "#325FDC", "#91BEFA"];

function getRandomColorIndex(colors) {
  return Math.floor(Math.random() * colors.length);
}

export function GlobalLoader({ visible }) {
  const [ringColorIndex, setRingColorIndex] = useState(0);
  const [ballColorIndex, setBallColorIndex] = useState(0);

  useEffect(() => {
    if (visible) {
      setRingColorIndex(0);
      setBallColorIndex(getRandomColorIndex(ballColors));
    }
  }, [visible]);

  if (!visible) {
    return null;
  }

  return (
    <div
      className="fixed inset-0 z-[1000] flex items-center justify-center bg-brand-surface/95 px-5 backdrop-blur-sm"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="flex h-40 w-40 items-center justify-center rounded-[2.5rem] border border-brand-primary/10 bg-white/85 shadow-soft backdrop-blur sm:h-48 sm:w-48">
        <div className="relative flex h-28 w-28 items-center justify-center sm:h-32 sm:w-32">
          <div className="absolute inset-0 rounded-full border-[4px] border-brand-surface/20" />
          <div
            className="absolute inset-0 rounded-full border-[4px] border-transparent border-t-current animate-spin"
            style={{ color: ringColors[ringColorIndex] }}
            onAnimationIteration={() => {
              setRingColorIndex((current) => (current + 1) % ringColors.length);
            }}
          />
          <MdSportsSoccer
            aria-hidden="true"
            className="relative z-10 h-12 w-12 sm:h-14 sm:w-14"
            style={{ color: ballColors[ballColorIndex] }}
          />
        </div>
      </div>
    </div>
  );
}
